export default {
  contentView: {
    flex: 1,
    paddingLeft: 20,
    paddingRight: 20,
  },
  contentText: {},
};
